// Иконки — те же контуры, что в артбордах. Никаких маскотов и звёздочек.

type Props = { size?: number; color?: string; width?: number };

function Svg({
  size = 20,
  color = "currentColor",
  width = 2,
  children,
}: Props & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={width}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export function IconReview(props: Props) {
  return (
    <Svg {...props}>
      <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
      <path d="M3 3v5h5" />
    </Svg>
  );
}

/** Раскрытие списка: вправо — свёрнуто, поворот на 90° — развёрнуто. */
export function IconChevron(props: Props) {
  return (
    <Svg {...props}>
      <path d="m9 6 6 6-6 6" />
    </Svg>
  );
}

export function IconNew(props: Props) {
  return (
    <Svg {...props}>
      <path d="M12 4v16" />
      <path d="M4 12h16" />
    </Svg>
  );
}

export function IconChallenge(props: Props) {
  return (
    <Svg {...props}>
      <path d="M12 3 4 9v6l8 6 8-6V9z" />
      <path d="M12 11v4" />
    </Svg>
  );
}

export function IconCheck(props: Props) {
  return (
    <Svg width={3} {...props}>
      <path d="M20 6 9 17l-5-5" />
    </Svg>
  );
}

export function IconCross(props: Props) {
  return (
    <Svg width={2.5} {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </Svg>
  );
}

export function IconArrow(props: Props) {
  return (
    <Svg {...props}>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </Svg>
  );
}

export function IconSun(props: Props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
    </Svg>
  );
}

export function IconMoon(props: Props) {
  return (
    <Svg {...props}>
      <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a7 7 0 1 0 10.5 10.5z" />
    </Svg>
  );
}

/** «Как в системе»: круг, залитый наполовину. */
export function IconAuto(props: Props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 4a8 8 0 0 0 0 16z" fill="currentColor" stroke="none" />
    </Svg>
  );
}

/**
 * Строка дня: компас. Совет говорит, КАК работать, — то есть про направление,
 * а не про оценку сделанного.
 *
 * Лампочки нет по той же причине, что у разбора: лампочка означает «подсказка
 * к этой задаче», а совет к задаче не относится вовсе. Звёздочки, галочки и
 * пальца вверх здесь не будет никогда — это знаки одобрения, а система
 * человека не оценивает.
 */
export function IconCompass(props: Props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="m15.6 8.4-2.3 5.2-5.2 2.3 2.3-5.2z" />
    </Svg>
  );
}

/** Разбор темы: раскрытая книга. Не «подсказка» — лампочки здесь нет намеренно. */
export function IconBook(props: Props) {
  return (
    <Svg {...props}>
      <path d="M12 6.5C10.6 5.2 8.8 4.5 6.5 4.5H3v13h3.5c2.3 0 4.1.7 5.5 2" />
      <path d="M12 6.5c1.4-1.3 3.2-2 5.5-2H21v13h-3.5c-2.3 0-4.1.7-5.5 2" />
      <path d="M12 6.5v15" />
    </Svg>
  );
}

/* ─── переходы в шапке ──────────────────────────────────────────────────────
   Шесть значков ниже стоят в одном ряду в шапке приложения (src/ui/AppNav.tsx),
   и различать их надо с одного взгляда, а не читая подпись. Поэтому силуэты
   намеренно непохожие: треугольник, оси, циферблат, человек, созвездие, лист.

   Треугольник стоит первым и ведёт туда же, куда имя продукта, — в набор дня.
   Два хода в одно место здесь намеренно: имя продукта читается как выход
   («уйти отсюда»), а значок — как работа («сесть решать»), и ищут их в разных
   случаях. Добавлен 24 сентября 2026 по просьбе владельца.                  */

/** Решать: треугольник «пуск». Ни круга, ни заливки — рядом циферблат, и
    силуэты не должны спорить. Пара к кнопке «Начать» на самом наборе дня. */
export function IconSolve(props: Props) {
  return (
    <Svg {...props}>
      <path d="M8 5.6 18.4 12 8 18.4z" />
    </Svg>
  );
}

/** Лаборатория графиков: оси и кривая на них. */
export function IconGraphLab(props: Props) {
  return (
    <Svg {...props}>
      <path d="M4 4v16h16" />
      <path d="M7 16c2.5 0 3.2-8 5.5-8s3 5 5.5 5" />
    </Svg>
  );
}

/** История: циферблат со стрелками. Кругового «повтора» здесь нет намеренно —
    им помечены повторения в наборе (IconReview), а это взгляд назад. */
export function IconHistory(props: Props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5.2l3.4 2" />
    </Svg>
  );
}

/** Личные данные: одно поле — имя. Значок человека, не шестерёнка: это не
    настройки, поведение системы здесь не меняется. */
export function IconPerson(props: Props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M5 20c0-3.6 3.1-5.6 7-5.6s7 2 7 5.6" />
    </Svg>
  );
}

/** Прогресс по карте: узлы и рёбра. Не «диаграмма роста» — карта. */
export function IconMap(props: Props) {
  return (
    <Svg {...props}>
      <circle cx="6" cy="7" r="2.3" />
      <circle cx="18" cy="6" r="2.3" />
      <circle cx="12" cy="18" r="2.3" />
      <path d="M8.3 7.3 15.7 6.3M7.2 9.1 10.9 15.9M17 8.1 13.2 15.8" />
    </Svg>
  );
}

/** Черновик: лист и карандаш над ним. */
export function IconDraft(props: Props) {
  return (
    <Svg {...props}>
      <path d="M12.5 4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6.5" />
      <path d="m9.6 15 .5-2.6 7.4-7.4a1.65 1.65 0 0 1 2.3 2.3L12.4 14.7z" />
      <path d="M8.5 18h5" />
    </Svg>
  );
}

/** Обратная связь: облачко реплики с восклицательным знаком. */
export function IconFeedback(props: Props) {
  return (
    <Svg {...props}>
      <path d="M20 11.5a7.5 7.5 0 0 1-10.9 6.7L4 19.5l1.3-4.6A7.5 7.5 0 1 1 20 11.5z" />
      <path d="M12.5 8v4" />
      <path d="M12.5 15.2h.01" />
    </Svg>
  );
}

/** Значки статусов и действий в очереди обратной связи. */
export function IconQuestion(props: Props) {
  return <Svg {...props}><path d="M9 9a3 3 0 1 1 5 2.3c-1.2.9-2 1.4-2 3" /><path d="M12 18h.01" /></Svg>;
}
export function IconClock(props: Props) {
  return <Svg {...props}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></Svg>;
}
export function IconPause(props: Props) {
  return <Svg {...props}><path d="M9 6v12M15 6v12" /></Svg>;
}
export function IconTrash(props: Props) {
  return <Svg {...props}><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v5M14 11v5" /></Svg>;
}
export function IconPaperclip(props: Props) {
  return <Svg {...props}><path d="m8 12 5.8-5.8a3 3 0 0 1 4.2 4.2l-7.7 7.7a5 5 0 0 1-7.1-7.1l8.4-8.4" /></Svg>;
}
export function IconList(props: Props) {
  return <Svg {...props}><path d="M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01" /></Svg>;
}
/** «Не совсем понятно» у разбора: вопрос в круге. */
export function IconUnclear(props: Props) {
  return <Svg {...props}><circle cx="12" cy="12" r="9" /><path d="M9.5 9.5a2.5 2.5 0 1 1 3.6 2.2c-.7.4-1.1.9-1.1 1.8" /><path d="M12 17h.01" /></Svg>;
}
/** «Решал иначе»: развилка пути. */
export function IconFork(props: Props) {
  return <Svg {...props}><circle cx="6" cy="18" r="2" /><circle cx="6" cy="6" r="2" /><circle cx="18" cy="6" r="2" /><path d="M6 8v8" /><path d="M18 8a6 6 0 0 1-6 6H6" /></Svg>;
}
/** Сообщения: облачко реплики с тремя точками строки. */
export function IconMessage(props: Props) {
  return <Svg {...props}><path d="M20 11.5a7.5 7.5 0 0 1-10.9 6.7L4 19.5l1.3-4.6A7.5 7.5 0 1 1 20 11.5z" /><path d="M8.5 11.5h.01M12.5 11.5h.01M16.5 11.5h.01" /></Svg>;
}
/** «Ответить письменно»: карандаш. */
export function IconPencil(props: Props) {
  return <Svg {...props}><path d="M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17z" /><path d="m14 7 3 3" /></Svg>;
}
/** «Нужна доработка разбора»: флажок. */
export function IconFlag(props: Props) {
  return <Svg {...props}><path d="M5 21V4" /><path d="M5 4h11l-2 4 2 4H5" /></Svg>;
}
/** «Попросить подробнее» у шага разбора: лупа с плюсом. */
export function IconMore(props: Props) {
  return <Svg {...props}><circle cx="11" cy="11" r="6.5" /><path d="m20 20-4.4-4.4M11 8.5v5M8.5 11h5" /></Svg>;
}

/* Панель «Оформление» — значки как в teen-english (Lucide). */
export function IconPalette(props: Props) {
  return (
    <Svg {...props}>
      <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
      <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
      <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
      <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.9 0 1.6-.7 1.6-1.7 0-.4-.2-.8-.4-1.1-.3-.3-.4-.7-.4-1.1a1.6 1.6 0 0 1 1.6-1.7h2c3 0 5.6-2.5 5.6-5.6C22 6 17.5 2 12 2z" />
    </Svg>
  );
}

export function IconSquare(props: Props) {
  return (
    <Svg {...props}>
      <rect x="4" y="4" width="16" height="16" rx="1" />
    </Svg>
  );
}

export function IconCircle(props: Props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="9" />
    </Svg>
  );
}

export function IconX(props: Props) {
  return (
    <Svg {...props}>
      <path d="M18 6 6 18M6 6l12 12" />
    </Svg>
  );
}

/** «Ещё» в нижней панели телефона. */
export function IconDots(props: Props) {
  return (
    <Svg {...props}>
      <circle cx="5" cy="12" r="1.2" fill="currentColor" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" />
      <circle cx="19" cy="12" r="1.2" fill="currentColor" />
    </Svg>
  );
}

/**
 * Знак продукта в боковом меню: буква P и квадрат ∎ — знак конца
 * доказательства. Один квадрат без буквы в мелком размере читается как
 * «стоп» в плеере. Тот же рисунок — в иконке вкладки (index.html).
 */
export function IconProof(props: Props) {
  return (
    <Svg {...props}>
      <path d="M7 20V4h5.5a4.5 4.5 0 0 1 0 9H7" />
      <rect x="14.5" y="14.5" width="6" height="6" rx="0.4" fill="currentColor" stroke="none" />
    </Svg>
  );
}

/** «Прогресс» в переходах: линия вверх по осям. */
export function IconTrend(props: Props) {
  return (
    <Svg {...props}>
      <path d="M3 3v18h18" />
      <path d="m7 15 4-4 3 3 6-6" />
    </Svg>
  );
}

/** «План» в переходах: календарь. */
export function IconCalendar(props: Props) {
  return (
    <Svg {...props}>
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
    </Svg>
  );
}
